import React, { useState } from 'react'
import PropTypes from 'prop-types'
import PointsInformation from './../../../Header/UserBasicInformation/PointsInformation'
import { Icon } from 'loyal-react'

const defaultState = {
  hideValue: false
}

const Profile = ({
  profile: { name },
  balance: { pointsValue },
  pointsName,
  decimalPlaces,
  openProfileMenu
}) => {
  const [ownState, setOwnState] = useState(defaultState)

  const formatPoints = (value) => {
    const decimal = Math.pow(10, decimalPlaces)

    const formated = Math.floor(parseFloat(value) * decimal) / decimal

    return (formated).toLocaleString('pt-br', {
      minimumFractionDigits: decimalPlaces || 0,
      maximumFractionDigits: decimalPlaces || 0
    })
  }

  const hideValue = () => {
    window.localStorage.setItem('hideValue', `${!ownState.hideValue}`)
    setOwnState({
      ...ownState,
      hideValue: !ownState.hideValue
    })
  }

  const returnPoints = () => {
    return `${formatPoints(pointsValue)} ${pointsName}`
  }

  const maskedValue = () => {
    let hiddenPoints = returnPoints()

    return hiddenPoints.replace(/./g, '*')
  }
  return (
    <li className='user-information px-1 h-auto border-brand-4 border-top bg-brand-4 mb-1'>
      <div className='row align-items-center h-100 pos-relative'>
        <div className='btn btn-user-information btn-sm btn-double btn-flat btn-icon txt-font-body txt-initial txt-body txt-left py-1 default abrir-menu-usuario'>
          <p className='txt-body-sm color-ui-white user-name'>
            {`Olá, ${formatName(name)}!`}
          </p>
          <div className='d-flex'>
            <div className='points-information-area d-flex'>
              <p
                className='txt-body-sm color-ui-white user-points d-flex align-items-center'
                aria-label={
                  window.localStorage.getItem('hideValue') === 'true' || ownState.hideValue
                    ? 'Sua pontuação está escondida.'
                    : `Você tem ${returnPoints()}.`
                }
              >
                <span className='hide-absolute user-information'>{
                  window.localStorage.getItem('hideValue') === 'true' || ownState.hideValue
                    ? 'Sua pontuação está escondida.'
                    : `Você tem ${returnPoints()}.`
                }</span>
                <div aria-hidden='true'>
                  <PointsInformation
                    hideValue={ownState.hideValue}
                    maskedValue={maskedValue()}
                    formatPoints={returnPoints()}
                  />
                </div>
              </p>
            </div>
            <div className='ml-1'>
              <a
                href='javascript:void(0)'
                className='d-inline-block ml-1 user-points'
                onClick={hideValue}
                aria-label={
                  window.localStorage.getItem('hideValue') === 'true' || ownState.hideValue
                    ? 'Exibir pontuação'
                    : 'Esconder pontuação'
                }
              >
                <span className='hide-absolute hide-points-menu'>{
                  window.localStorage.getItem('hideValue') === 'true' || ownState.hideValue
                    ? 'Exibir pontuação'
                    : 'Esconder pontuação'
                }</span>
                <Icon
                  iconName={window.localStorage.getItem('hideValue') === 'true' || ownState.hideValue ? 'icon_no_view' : 'icon_view'}
                  className='color-brand-5 txt-body-sm position-relative pos-relative l-0 t-0'
                />
              </a>
            </div>
          </div>
        </div>
        <button
          className='btn btn-open-user-menu btn-sm btn-double btn-flat btn-icon txt-font-body txt-initial txt-body txt-left py-1 default abrir-menu-usuario'
          onClick={openProfileMenu}
          aria-label='Abrir menu de usuário'
          role='button'
          tabIndex='-1'
        >
          <span className='hide-absolute open-user-menu'>{ownState.isFlagChoiceOpened ? 'Fechar seleção do formato' : 'Selecionar formato de resgate' }</span>
        </button>
      </div>
    </li>
  )
}

const formatName = name => {
  return name.split(' ')[0]
}

Profile.propTypes = {
  profile: PropTypes.object,
  balance: PropTypes.object,
  pointsName: PropTypes.string,
  openProfileMenu: PropTypes.func,
  decimalPlaces: PropTypes.number
}

export default Profile



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuMobile/Profile/Profile.js